import { useEffect } from "react";
import {
  Box,
  Text,
  Button,
  Flex,
  Image,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
} from "@chakra-ui/react";
import { useNavigate, useLocation } from "react-router-dom";
import model from "../../assets/popup/model.png";
import { usePopupTrigger } from "./UsePopUpTrigger";

const isLoggedIn = () => !!localStorage.getItem("token");

export default function Popup() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    localStorage.removeItem("popupClosed");
  }, []);

  usePopupTrigger(() => {
    if (!isLoggedIn()) onOpen();
  }, location);

  const handleSignupRedirect = () => {
    navigate("/create");
    onClose();
  };

  const handleClose = () => {
    localStorage.setItem("popupClosed", "true");
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} size="xl" isCentered>
      <ModalOverlay bg="blackAlpha.600" />
      <ModalContent
        p={0}
        maxW="900px"
        borderRadius="md"
        overflow="hidden"
        boxShadow="lg"
        bg="#F2EEE8"
        mx={{ base: 4, md: 0 }}
        my={{ base: 6, md: 0 }}
      >
        <Flex direction={{ base: "column", md: "row" }} w="full">
          <ModalCloseButton
            position="absolute"
            top="10px"
            right="10px"
            zIndex="1"
            color="white"
            bg="blackAlpha.600"
            _hover={{ bg: "blackAlpha.700" }}
            onClick={handleClose}
          />

          <Box
            flex="1"
            px={{ base: 6, md: 10 }}
            py={{ base: 8, md: 10 }}
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="flex-start"
          >
            <Text fontSize="2xl" fontWeight="thin" mb={2}>
              Sign up
            </Text>
            <Text fontSize="3xl" fontWeight="thin" mb={4}>
              Get 100 points
            </Text>
            <Text fontSize="sm" color="gray.600" mb={6}>
              Create your account and get your desired product delivered to you.
              Get 100 points as a welcome gift to use in your purchase.
            </Text>

            <Button
              color="white"
              bg="black"
              variant="solid"
              onClick={handleSignupRedirect}
              _hover={"none"}
            >
              Create My Account
            </Button>
          </Box>

          <Box
            flex="1"
            display="block"
            pt={{ base: 4, md: 10 }}
            px={{ base: 6, md: 10 }}
            pb={{ base: 6, md: 10 }}
          >
            <Image
              src={model}
              alt="Shopping Model"
              objectFit="cover"
              borderRadius="md"
              w="100%"
              maxH={{ base: "280px", md: "360px" }}
              mx="auto"
            />
          </Box>
        </Flex>
      </ModalContent>
    </Modal>
  );
}
